import { Autoplay, Controller, Navigation, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, Navigation]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementsByClassName('js-slider')) {
  const slideLength = document.querySelectorAll('.js-slider .swiper-slide').length

  const initSwiper = () => {
    const ServiceSlider = new Swiper('.js-slider', {
      slidesPerView: 1.8,
      spaceBetween: 20,
      loop: true,
      speed: 6000,
      loopedSlides: 1.8,
      autoplay: {
        delay: 0,
        disableOnInteraction: true,
      },
      breakpoints: {
        // スライドの表示枚数：767px以上の場合
        767: {
          slidesPerView: 1.6,
          loopedSlides: 1.6,
          spaceBetween: 30,
          centeredSlides: false,
        },
        1000: {
          slidesPerView: 1.9,
          loopedSlides: 1.9,
          spaceBetween: 30,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 2.6,
          loopedSlides: 2.6,
          spaceBetween: 30,
          centeredSlides: false,
        },
        1280: {
          slidesPerView: 2.8,
          loopedSlides: 2.8,
          spaceBetween: 40,
          centeredSlides: false,
        },
      },
    })
  }
  window.addEventListener('load', function () {
    initSwiper()
  })
}
// if (document.getElementsByClassName('interview__list')) {
//   let InterviewSlider = new Swiper('.interview__list', {
//     slidesPerView: 2.2,
//     spaceBetween: 20,
//     loop: true,
//     centeredSlides: true,
//     autoplay: {
//       delay: 3000,
//     },
//     breakpoints: {
//       // スライドの表示枚数：767px以上の場合
//       767: {
//         slidesPerView: 2.2,
//         spaceBetween: 20,
//         centeredSlides: false,
//       },
//       // スライドの表示枚数：1000px以上の場合
//       1000: {
//         slidesPerView: 2.8,
//         spaceBetween: 30,
//         centeredSlides: true,
//       },
//       // スライドの表示枚数：1025px以上の場合
//       1025: {
//         slidesPerView: 4,
//         spaceBetween: 40,
//         centeredSlides: false,
//       },
//     },
//   })
// }

//FAQ処理
const faqTitle = document.querySelectorAll('.js-qa__title')

for (let i = 0; i < faqTitle.length; i++) {
  faqTitle[i].addEventListener('click', accodionToggle)
}

// 処理
function accodionToggle(e) {
  e.currentTarget.classList.toggle('is-open')
  const child = e.currentTarget.nextElementSibling
  child.classList.toggle('is-open')
}
